/* eslint-disable max-len */
import { MenuService } from './../../../../themes/services/menu.service';
import { combineLatest, Observable, of, Subject, filter, map, switchMap, take, takeUntil, tap } from 'rxjs';
import { AuthService } from '@uw/core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CampaignPageContent,
  CampaignTypes,
} from '@uw/core/models/campaign.model';
import { MatDialog } from '@angular/material/dialog';
import { DonationOptoutModalComponent } from '../../modals/donation-optout-modal/donation-optout-modal.component';
import { removePlaceholders } from '@uw/core/services/utils.service';
import { ProfileService } from '@uw/core/services/profile.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignFacadeService } from '@uw/core/facades/campaign.facade.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LangSelectorModalComponent } from '@uw/shared/components/lang-selector-modal/lang-selector-modal.component';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { MyCampaignModalComponent } from '../../modals/my-campaign-modal/my-campaign-modal.component';
import { CampaignLanguageBaseComponent } from '@uw/core/campaign-language-base-component.component';
import { LanguageService } from '@uw/core/language.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { MatButton } from '@angular/material/button';
import { UwRouterLink } from '../../../../shared/directives/directives/uw-router-link.directive';
import { SafeHtmlPipe } from '../../../../shared/pipes/santized-html.pipe';

@Component({
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss'],
    imports: [NgIf, ButtonComponent, MatButton, UwRouterLink, AsyncPipe, SafeHtmlPipe, TranslateModule]
})
export class WelcomePageComponent extends CampaignLanguageBaseComponent implements OnInit {
  isUserLoggedIn: boolean;
  buttonLoading = false;
  pageContent!: Map<string, CampaignPageContent>;

  isUserLogedId$: Observable<boolean>;
  welcomeSideImage!: string | null;
  myCampaignImage!: string | null;
  myCampaignButtonLabel!: string | null;
  welcomeMessage!: string | null;
  welcomeParagraphs!: string | null;
  displayCampaignEndedDialog$ = new Subject<boolean>();
  displayContent = false;

  aboutUsParagraph:
    | string
    | null = `<div><br></div><div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat congue massa, sed dapibus justo consequat eget. Mauris varius justo eget sapien iaculis vulputate. Morbi itae eros quis tellus vehicula cursus ut et est.</div><div><br></div><div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat congue massa, sed dapibus justo consequat eget. Mauris varius justo eget sapien iaculis vulputate. Morbi itae eros quis tellus vehicula cursus ut et est.</div><h1><br></h1><h1><strong style="color: rgb(228, 82, 5);">“Here is a quote that we want to bring out”</strong></h1><div><strong style="color: rgb(228, 82, 5);"><span class="ql-cursor"></span></strong></div><div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean feugiat congue massa, sed dapibus justo consequat eget. Mauris varius justo eget sapien iaculis vulputate. Morbi itae eros quis tellus vehicula cursus ut et est.</div><div><br></div>`;
  aboutUsHeading!: string | null;
  aboutUsImage!: string | null;

  box1Image!: string | null;
  box2Image!: string | null;
  box3Image!: string | null;
  box4Image!: string | null;

  box1Alt!: string | null;
  box2Alt!: string | null;
  box3Alt!: string | null;
  box4Alt!: string | null;
  welcomeSideImageAlt!: string | null;
  myCampaignSideImageAlt!: string | null;
  aboutUsImageAlt!: string | null;
  showOptOutOption$!: Observable<boolean>;
  campaignGuid!: string;
  isDonationExist$: Observable<boolean>;

  readonly donateButtonLable$ = this.campaignService.getPageContent(this.campaignStateService.getSelectedCampaign()?.campaignGuid, 'welcome').pipe(
    map(data => {
      let donateButtonLabel = 'button.donate_now', tooltipText = 'button.donate_now';
      if (data && data.size > 0) {
        const labelContent = this.getContent('DonateButtonLabel', data) || donateButtonLabel;
        let donateButtonLblFromContent = labelContent && labelContent.replace(/<[^>]+>/g, '').trim();
        //Decode HTML entities
        if (donateButtonLblFromContent) {
          const div = document.createElement("div");
          div.innerHTML = donateButtonLblFromContent;      
          donateButtonLblFromContent = div.textContent || "";
        }
        donateButtonLabel = donateButtonLblFromContent ? donateButtonLblFromContent : 'button.donate_now';
        tooltipText = donateButtonLabel;        
        if (window.innerWidth < 768 && tooltipText.length > 17) {
          donateButtonLabel = tooltipText.slice(0, 17) + '...'; // 17 is the character limit to display button appropriately
        } else {
          donateButtonLabel = tooltipText;
        } 
      }
      return {donateButtonLabel, tooltipText};
    })
  );

  readonly link1Content$ = this.campaignService
    .getPageContent(
      this.campaignStateService.getSelectedCampaign()?.campaignGuid,
      'linkpage1'
    )
    .pipe(
      map((data) => {
        if (!data || (data && data.size == 0)) {
          return null;
        }
        return this.loadLinkPageContent(data);
      })
    );

  readonly link2Content$ = this.campaignService
    .getPageContent(
      this.campaignStateService.getSelectedCampaign()?.campaignGuid,
      'linkpage2'
    )
    .pipe(
      map((data) => {
        if (!data || (data && data.size == 0)) {
          return null;
        }
        return this.loadLinkPageContent(data);
      })
    );

  readonly link3Content$ = this.campaignService
    .getPageContent(
      this.campaignStateService.getSelectedCampaign()?.campaignGuid,
      'linkpage3'
    )
    .pipe(
      map((data) => {
        if (!data || (data && data.size == 0)) {
          return null;
        }
        return this.loadLinkPageContent(data);
      })
    );

  readonly link4Content$ = this.campaignService
    .getPageContent(
      this.campaignStateService.getSelectedCampaign()?.campaignGuid,
      'linkpage4'
    )
    .pipe(
      map((data) => {
        if (!data || (data && data.size == 0)) {
          return null;
        }
        return this.loadLinkPageContent(data);
      })
    );

    readonly showMyCampaignLink$ = combineLatest([
      this.campaignService.getMyCampaignDetails(
        this.campaignStateService.getSelectedCampaign().campaignGuid
      ),
      this.campaignService
        .getCampaingInfo(this.campaignStateService.getSelectedCampaign().campaignGuid)
        .pipe(map((data) => data.type.isCampaignClosed)),
    ]).pipe(
      map(
        ([myCampaignDetail, isCampaignClosed]) =>
          !isCampaignClosed &&
          (myCampaignDetail.isThermometerVisible ||
            myCampaignDetail.isGroupThermometerVisible)
      )
    );

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private menuService: MenuService,
    private customNavigationService: CustomNavigationService,
    private campaignFacade: CampaignFacadeService,
    private campaignStateService: CampaignStateService,
    private campaignService: CampaignService,
    private authService: AuthService,
    private translate: TranslateService,
    _languageService: LanguageService,
  ) {
    super(_languageService, campaignStateService);
    this.menuService.hideNav = false;
    this.menuService.showCampaignSpecificLogos$.next(true);
    this.menuService.hideOnlyRightNav = false;
    this.menuService.showDonarSubMenu(false);
  }

  ngOnInit(): void {
    super.ngOnInit();

    const selectedCampaign = this.campaignStateService.getSelectedCampaign();

    this.campaignGuid = selectedCampaign?.campaignGuid ?? '';

    this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data.pageContent) {
        this.pageContent = data.pageContent;
        this.loadContent();
      }
    });

    this.displayCampaignEndedDialog$.pipe(
      switchMap(_ => this.campaignService.getCampaingInfo(this.campaignGuid).pipe(map(data=> data.type.isCampaignClosed))),
      tap(campaignClosed => this.displayContent = !campaignClosed),
      filter(campaignClosed => campaignClosed),
      takeUntil(this.destroy$)
    ).subscribe(
      _ => {
        this.customNavigationService.navigate(['closed-campaign'], { relativeTo: this.route });
      }
    )

    this.authService
      .getUserState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.isUserLoggedIn = !!data;
        if (data) {
          this.profileService.getoptOutCampaignStatus().subscribe();
          this.loadPlaceHolders();
        } else {
          this.removePlaceHolder();
        }
      });

    this.isDonationExist$ = this.authService
    .getUserState()
    .pipe(
      switchMap((user) =>
        user ? this.campaignService.isUserDonationExist() : of(false)
      )
    );

    this.showOptOutOption$ = this.isDonationExist$
      .pipe(
        filter(isDonationExist => !isDonationExist),
        switchMap(
          _ =>
            this.profileService
      .isUserOptOut()

        ),
        switchMap(
          (optOut) =>
            of(
              this.campaignStateService.getSelectedCampaign().campaignType ===
                CampaignTypes.Regular
            ) &&
            this.authService
              .getUserState()
              .pipe(map((user) => !!user && !optOut))
        ),
        takeUntil(this.destroy$)
      );

    const isLiteCampaignBiLingualFlagStored = sessionStorage.getItem(
      'isLiteCampaignBiLingual'
    );

    if (
      //!this.authService.isUserLoggedId() &&
      selectedCampaign.isBilingual &&
      selectedCampaign.liteCampaignType &&
      selectedCampaign.languageSelectionEnabled &&
      !isLiteCampaignBiLingualFlagStored
    ) {
      let dialogRef = this.dialog.open(LangSelectorModalComponent, {
        disableClose: true,
        panelClass: 'langauge-modal',
        backdropClass: 'dark-backdrop',
        width: '600px',
      });

      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((lang) => {
          if (lang) {
            localStorage.setItem('lang', lang);
            this.translate.use(lang);
            sessionStorage.setItem('isLiteCampaignBiLingual', 'yes');
            window.location.reload();
          }
          dialogRef = null;
        });
    } else {
      this.displayCampaignEndedDialog$.next(true);
    }
  }

  loadLinkPageContent(pageContent: Map<string, CampaignPageContent>) {
    const pageTitle = this.getContent('PageTitle', pageContent);
    const contentDetail = this.getContent('PageContent', pageContent);

    return { pageTitle, contentDetail };
  }

  onPastDonation() {
    this.customNavigationService.navigate(['/donor-info']);
  }

  onDonateNow() {
    const currenctCampaign = this.campaignStateService.getSelectedCampaign();

    if (currenctCampaign.campaignType === CampaignTypes.Regular) {
      if (!this.authService.getUser()) {

        // Inorder to prevent 2fa flow from breaking, commented out below logic
        // to navigate to sidebar login, and sending user to standalone login page.
        // Logic of how to navigate a user with regular campaign can be implemented in later phase.
        this.customNavigationService.navigate(['main/login']);


        return;
      }
    }

    if (!this.isUserLoggedIn){
      this.customNavigationService.navigate(['/donor', this.campaignStateService.getSelectedCampaign()?.campaignGuid, 'donation'], { queryParamsHandling: 'preserve' });
      return;
    }
    this.campaignService
      .getAprDonationSummary()
      .pipe(
        switchMap((donationSummaryList) => {
          const selectedCampignGuid = this.campaignStateService.getSelectedCampaign()?.campaignGuid;
          const campaignSpecificAprs = donationSummaryList && donationSummaryList.filter(apr => apr.campaignGuid == selectedCampignGuid);
          if (campaignSpecificAprs &&  campaignSpecificAprs.length > 0) {
            return this.showOtherDonationDialog().pipe(
              map((navigate) => ({ navigate }))
            );
          } else {
            return of({ navigate: true });
          }
        }),
        take(1)
      )
      .subscribe((result) => {
        if (result.navigate) {
          this.customNavigationService.navigate(
            [
              '/donor',
              this.campaignStateService.getSelectedCampaign()?.campaignGuid,
              'donation',
            ],
            { queryParamsHandling: 'preserve' }
          );
        }
      });
  }

  onMyCampaignClick() {

   this.dialog.open(MyCampaignModalComponent, {
      data: {
        title: this.myCampaignButtonLabel,
        sideImgSrc: this.myCampaignImage,
        sideImageAlt: this.myCampaignSideImageAlt
      },
      disableClose: true,
    });
  }

  showOtherDonationDialog() {
    const dialogRef = this.layoutUtilsService.customConfirmationElement(
      'welcome_page.make_additional_donation_dialog_title',
      'welcome_page.make_additional_donation_msg',
      '',
      'common.yes',
      true,
      'common.no'
    );

    // on confirm click
    dialogRef.componentInstance.confirmed().pipe(
      filter((confirm) => confirm),
      tap((_) => {
        dialogRef.componentInstance.viewLoading = false;
        dialogRef.close('Dialog closed after confirmation');
      })
    ).subscribe();

    return dialogRef.afterClosed().pipe(
      map((result) => {
        return !!result;
      })
    );
  }

  onOptOut() {
    this.campaignService
      .getPageContent(this.campaignGuid, 'OptOut')
      .subscribe((data) => {
        const _dialogRef = this.dialog.open(DonationOptoutModalComponent, {
          data,
          panelClass: 'optOut-modal',
          width: '550px',
        });
      });
  }

  onOptIn() {
    this.profileService.optInCampaign().subscribe();
  }

  showDonarSubMenu() {
    this.menuService.showDonarSubMenu(true);
  }

  loadContent() {
    this.welcomeSideImage = this.getImageSrcName(
      this.getContent('Welcome_SideImage', this.pageContent) ?? ''
    );
    this.myCampaignImage = this.getImageSrcName(
      this.getContent('MyCampaign_Image', this.pageContent) ?? ''
    );

    const myCampaignLabelContent = this.getContent('MyCampaign_Button', this.pageContent);

    this.myCampaignButtonLabel = myCampaignLabelContent && myCampaignLabelContent.replace(/<[^>]+>/g, '').trim();
    this.welcomeMessage = this.getContent('Welcome_Heading', this.pageContent);
    this.welcomeParagraphs = this.getContent(
      'Welcome_Message',
      this.pageContent
    );
    this.box1Image = this.getImageSrcName(
      this.getContent('Metric_1_Image', this.pageContent) ?? ''
    );
    this.box2Image = this.getImageSrcName(
      this.getContent('Metric_2_Image', this.pageContent) ?? ''
    );
    this.box3Image = this.getImageSrcName(
      this.getContent('Metric_3_Image', this.pageContent) ?? ''
    );
    this.box4Image = this.getImageSrcName(
      this.getContent('Metric_4_Image', this.pageContent) ?? ''
    );

    this.box1Alt = this.getImageAltText(
      this.getContent('Metric_1_Image', this.pageContent) ?? ''
    );
    this.box2Alt = this.getImageAltText(
      this.getContent('Metric_2_Image', this.pageContent) ?? ''
    );
    this.box3Alt = this.getImageAltText(
      this.getContent('Metric_3_Image', this.pageContent) ?? ''
    );
    this.box4Alt = this.getImageAltText(
      this.getContent('Metric_4_Image', this.pageContent) ?? ''
    );
    this.welcomeSideImageAlt = this.getImageAltText(
      this.getContent('Welcome_SideImage', this.pageContent) ?? ''
    );
    this.myCampaignSideImageAlt = this.getImageAltText(
      this.getContent('MyCampaign_Image', this.pageContent) ?? ''
    );
    this.aboutUsImageAlt = this.getImageAltText(
      this.getContent('AboutUs_Image', this.pageContent) ?? ''
    );
    this.aboutUsHeading = this.getContent('AboutUs_Heading', this.pageContent);
    this.aboutUsParagraph = this.getContent(
      'AboutUs_Message',
      this.pageContent
    );
    this.aboutUsImage = this.getImageSrcName(
      this.getContent('AboutUs_Image', this.pageContent) ?? ''
    );
    this.aboutUsImage =
      this.aboutUsImage?.replace('src', 'class="aboutus_image" src') ?? '';
    if (!this.authService.isUserLoggedId()) {
      this.welcomeMessage = removePlaceholders(this.welcomeMessage);
    } else {
      this.loadPlaceHolders();
    }
  }

  loadPlaceHolders() {
    this.welcomeMessage = this.getContent('Welcome_Heading', this.pageContent);
    const firstName = this.authService.getUser()?.firstName ?? '';
    this.welcomeMessage =
      this.welcomeMessage?.replace('%FIRST_NAME%', firstName) ?? '';
  }

  removePlaceHolder() {
    this.welcomeMessage = this.getContent('Welcome_Heading', this.pageContent);
    this.welcomeMessage = removePlaceholders(this.welcomeMessage);
  }

  getContent(key: string, pageContent: Map<string, CampaignPageContent>) {
    if (pageContent && pageContent.has(key)) {
      return pageContent.get(key)?.contentXML ?? null;
    }
    return null;
  }

  getImageSrcName(imageElement: string): string | null {
    let m;
    const rex = /<img[^>]+src="?([^"\s]+)"?[^>]*>/g;

    imageElement = imageElement.replace('"', '"');
    while ((m = rex.exec(imageElement))) {
      return m[1];
    }
    return null;
  }

  getImageAltText(imageElement: string): string | null {
    let m;
    const rex = /alt="([\s\w]*)"+[^>]*/g;

    imageElement = imageElement.replace('"', '"');
    //console.log(str);
    while ((m = rex.exec(imageElement))) {
      // urls.push( m[1] );
      return m[1];
    }
    return null;
  }
}
